import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FaceSurpriseIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM10 5C9.44771 5 9 5.44772 9 6V6.5C9 6.77614 9.22386 7 9.5 7H10.5C10.7761 7 11 6.77614 11 6.5V6C11 5.44772 10.5523 5 10 5ZM5 6C5 5.44772 5.44772 5 6 5C6.55228 5 7 5.44772 7 6V6.5C7 6.77614 6.77614 7 6.5 7H5.5C5.22386 7 5 6.77614 5 6.5V6ZM8 8C6.89543 8 6 8.89543 6 10C6 11.1046 6.89543 12 8 12C9.10457 12 10 11.1046 10 10C10 8.89543 9.10457 8 8 8Z"
			/>
		</svg>
	),
)
